import React from 'react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { TruckIcon, ShieldCheckIcon, BatteryIcon, ShoppingCartIcon, StarIcon } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-12 md:pt-12 md:pb-16 px-4 bg-white" data-id="element-66">
      <div className="max-w-3xl mx-auto text-center" data-id="element-67">
        {/* Badges */}
        <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-68">
          <Badge text="Envío Gratis OCA" icon={TruckIcon} variant="success" data-id="element-69" />
          <Badge text="Cambio directo 180 días" icon={ShieldCheckIcon} variant="success" data-id="element-70" />
          <Badge text="USB o Pilas" icon={BatteryIcon} variant="neutral" data-id="element-71" />
        </div>

        {/* Headline */}
        <h1 className="text-3xl md:text-5xl font-extrabold text-[#111827] leading-tight mb-4" data-id="element-72">
          Transformá el miedo a la oscuridad en un momento mágico
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-[#4B5563] mb-8 max-w-2xl mx-auto" data-id="element-73">
          El Proyector de Estrellas 360° que acompaña el sueño de tu hijo,
          creando una rutina relajante y segura cada noche.
        </p>

        {/* Video */}
        <div className="relative aspect-square max-w-lg mx-auto bg-gray-900 rounded-2xl overflow-hidden shadow-xl mb-8" data-id="element-74">
          <video className="w-full h-full object-cover" src="https://res.cloudinary.com/dyjeiw2k1/video/upload/v1771205592/Video_Project_ks98kb.mp4" autoPlay loop muted playsInline controls data-id="element-75" />
        </div>
      </div>
    </section>;
}